import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withLocalize } from "react-localize-redux";
import _ from 'lodash';


import SelectAddField from '../input/SelectAddField';



import ContainerTranslation from "../partials/ContainerTranslation";
import history from '../../history';
import CollaboratorList from './CollaboratorList';
import ProjectList from './ProjectList';
import DocumentList from './DocumentList';
import { fetchProgram, uploadPicture, getAutocompleteList, updateFieldProgram } from '../../actions/program'
import { createRex } from '../../actions/rex'
import { createEightD } from '../../actions/eightD'
import Progress from '../partials/Progress';

class ProgramView extends React.Component {

  fourth = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    }
    this.props.fetchProgram(this.props.match.params.id);
    this.props.getAutocompleteList(this.props.match.params.id);
  }



  componentDidUpdate(prevProps) {




    if( this.state.isLoading && this.props.rexmessage === "Rex successfully removed!" ){
      this.props.fetchProgram(this.props.match.params.id);
      this.setState({isLoading:false})
    }

    if(this.props.rex._id && this.props.rexmessage === "Created Rex" ){
      history.push('/rex/edit/' + this.props.rex._id);
    }
    
    if(this.props.eightD._id && this.props.eightDmessage === "Created EightD"  ){
      history.push('/8D/edit/' + this.props.eightD._id);
    }
  }


    handleDemote() {
        this.props.updateFieldProgram({ parent: 'projectManager', value: null, name: '' }, this.props.program._id)
    }

  uploadPicture(files) {
    return 
    // if (files[0]) {
    //   this.props.uploadPicture(files[0], this.props.match.params.id)
    // }
  }


  renderAddCollaborators() {
    let options = []
    _.each(Object.entries(this.props.list.collaborators), function (entry) {
        const id = entry[0];
        const fullname = entry[1];
        if (fullname){
            return options.push({id : id, fullname: fullname});
        }
    });

    return <SelectAddField
    type={"collaborators"}
    noLabel={true}
    isRequired={false}
    id={this.props.match.params.id}
    placeholder={"Select a consultant"}
    section={'collaborators'}
    parent={'collaborators'}
    options={options} />;
}
  

renderAddProjects() {
  let options = []
  _.each(Object.entries(this.props.list.projects), function (entry) {
      const id = entry[0];
      const fullname = entry[1];
      if (fullname){
          return options.push({id : id, fullname: fullname});
      }
  });

  return <SelectAddField
  type={"programProject"}
  noLabel={true}
  isRequired={false}
  id={this.props.match.params.id}
  placeholder={"Select a project"}
  section={'projects'}
  parent={'projects'}
  options={options} />;
}


createRex() {
  this.props.createRex(this.props.match.params.id)
  
}

createEightD() {
  this.props.createEightD(this.props.match.params.id)
  
}


  render() {

    let route = null;
    
    if (Object.keys(this.props.program).length === 0) {
      return (
        <h3>Loading...</h3>
      )
    }

    if (this.props.program.authorization.write) {
      route = "/program/edit/" + this.props.program._id
    };

    // {/* <button className="primary-btn filling" style={{float:"right",width:"156px",height:"48px"}} onClick={this.togglePopup.bind(this)} >       </button> */}
    // this.props.program.validationInformation
      return (
        
      <>

      <div className="dashboard">
        {(Object.keys(this.props.program).length === 0 || Object.keys(this.props.list).length === 0) ?
          <h3 style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</h3>
          :
          <div>
            <div className="dashboard-header">
              <div style={{width: 'calc(100% - 200px)'}}>
                <Progress progression={this.props.program.progression} 
                            validationInformation = {{"user":"","timestamp":"","validationStatus":"document_validation_status_draft"}} 
                            title = {this.props.program.content.information.name}
                            kind = "Program"
                />
              </div>
              <div style={{flex : 1}}> 
              {route ?
                  <Link className="primary-btn filling" style={{float:"right",width:"110px",height:"48px", lineHeight:"normal"}} to={route}>
                    edit program
                  </Link>
                  :
                  null
                }
                {/* <Link className="primary-btn filling" style={{float:"right",width:"110px",height:"48px"}} to={route}>edit program
                </Link> */}
              </div>  
            </div>
            {this.props.program.content ?
              <div className="dashboard-content">

                <div className="col-1-3">

                  {/*PICTURE*/}
                  {this.props.program.picture64 ?
                    <img src={this.props.program.picture64} width="100%" alt="consultant" />
                    :
                    null
                  }

                  {/* <div className="input-container files" style={{ textAlign: 'center', marginTop: '10px' }}>
                    <label htmlFor='picture'>Mettre à jour l'image du programme</label>
                    <input type="file"
                    style={{ display: "none" }}
                    onChange={(e) => this.uploadPicture(e.target.files)}
                    id='picture' />
                  </div> */}


                  {/*INFORMATION*/}
                                      <div className="bloc">
                                          <span>Information général sur le programme</span>
                                          <p className="bloc-content">
                                              <ContainerTranslation id={['content'] + "." + ['information'] + "." + ['update-date']} /> {this.props.program.updatedAt.slice(0, 10)}
                                          </p>

                                          <div style={{ marginTop: '10px' }}>
                                              <div style={{ display: 'inline-block' }}>
                                                  {this.props.program.content.information['start-date']}
                                              </div>
                                              <div style={{ float: 'right', display: 'inline-block' }}>
                                                  {this.props.program.content.information['end-date']}
                                              </div>
                                              <div style={{ marginTop: '10px' }}>
                                                  <div className="dot-date">
                                                  </div>
                                                  <div className="line-date">
                                                  </div>
                                                  <div className="dot-date">
                                                  </div>
                                              </div>
                                          </div>
                                          <p className="bloc-title" style={{ marginBottom: 0 }}>Chef de projet</p>
                                          
                                          {this.props.program.projectManager ?
                                              <div className="line">
                                                  <p style={{ color: '#181E23' }}>
                                                      {this.props.program.projectManager.sageContent.profile.firstName + " " + this.props.program.projectManager.sageContent.profile.lastName}
                                                  </p>
                                                  {this.props.program.authorization.validate ?
                                                      <div onClick={this.handleDemote.bind(this)} style={{ display: "inline-block", width: "auto", lineHeight: "30px" }} title="Demote project manager">
                                                          <i class="fas fa-arrow-down" style={{ marginRight: "10px", marginLeft: "10px" }}></i>
                                                      </div>
                                                      : null
                                                  }
                                              </div> : <div className="line">
                                                  <p style={{ color: '#181E23' }}>No project manager assigned</p>
                                              </div>
                                          }
                                      </div>




                                  </div>

                {/*LEFT PART*/}

                <div className="col-2-3">

                  {/*NOTES*/}
                  <div className="bloc">
                    <span>Information technique sur le programme</span>
                    <p className="bloc-title" style={{ marginBottom: 0 }}>
                      Description du programme
                    </p>
                    <p className="bloc-content" style={{ color: '#181E23' }}>
                      {this.props.program.content.notes['description']}<br />
                    </p>
                  </div>
                  <div className="bloc">
                    {this.props.program.authorization.validate ? this.renderAddCollaborators() : null}
                    <CollaboratorList items={this.props.program.collaborators}  permission={this.props.program.authorization} docId={this.props.match.params.id} /> 
                  </div>
                  <div className="bloc">
                    {this.props.program.authorization.write ? this.renderAddProjects() : null}
                    <ProjectList items={this.props.program.projects}  permission={this.props.program.authorization} docId={this.props.match.params.id} /> 
                  </div>
                  <div className="bloc">
                  {this.props.program.authorization.write ? 
                        <>
                        <button className="primary-btn circle-add" onClick={this.createRex.bind(this)}></button> 
                        <p style={{display:"inline-block"}}>Ajouter un document REX</p> 
                        </>
                        : null
                  }
                    
                    <DocumentList items={this.props.program.rex} setLoading={()=>{this.setState({isLoading:true})}} readOnly={!this.props.program.authorization.validate} endpoint={"/rex/"} docId={this.props.match.params.id} /> 
                  </div>
                  <div className="bloc">
                  {this.props.program.authorization.write ? 
                        <>
                        <button className="primary-btn circle-add" onClick={this.createEightD.bind(this)}></button>
                        <p style={{display:"inline-block"}}>Ajouter un document 8D</p>
                        </>
                        : null
                  }
                    <DocumentList items={this.props.program.eightD} readOnly={!this.props.program.authorization.validate} endpoint={"/8D/"} docId={this.props.match.params.id} /> 
                  </div>
                </div>


              </div>
              :
              null
            }

          </div>
        }
      </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  program: state.program.program,
  message: state.program.message,
  list: state.program.list,
  rex: state.rex.rex,
  rexmessage: state.rex.message,
  eightD: state.eightD.eightD,
  eightDmessage: state.eightD.message,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchProgram,
    uploadPicture,
    updateFieldProgram,
    getAutocompleteList,
    createRex,
    createEightD
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(withLocalize(ProgramView)));
